import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  // isLoading = false;
  // fileloading = false;
  // isBlocked = false;
  // blockedCount = 0;
  // percent = 30;
  // speed = 0;
  // newSpeed = 0;
  // current = 0;
  // count = 0;
  // speedUpdate = interval(1000);
  //
  // triggered = new Subject();
  // autoUnblockTimeout: any;
  //
  // private _threshold = 90;
  // private _timer: any = null;
  //
  // constructor(
  //   private zone: NgZone,
  //   private lgDialogService: LgDialogService,
  //   private router: Router
  // ) {
  //
  // }
  //
  // startFileUploading(count = 1) {
  //   this.setCount(count);
  //   this.current = 0;
  //   this.fileloading = true;
  //   this.percent = 0;
  //   this.speed = 0;
  //
  //   this.speedUpdate
  //     .subscribe(() => {
  //       this.speed = this.newSpeed;
  //     });
  // }
  //
  // stopFileUploading() {
  //   this.fileloading = false;
  // }
  //
  // setCount(count: number) {
  //   this.count = count;
  //   this.triggered.next(null);
  // }
  //
  // setCurrent(current: number) {
  //   this.current = current;
  //   this.triggered.next(null);
  // }
  //
  // setSpeed(speed: number) {
  //   this.newSpeed = speed;
  //   this.triggered.next(null);
  // }
  //
  // block(maxBlockTimeMs = 0) {
  //   this.isBlocked = true;
  //   this.triggered.next(null);
  //   this.blockedCount++;
  //   if (maxBlockTimeMs) {
  //     clearTimeout(this.autoUnblockTimeout);
  //     this.autoUnblockTimeout = setTimeout(() => {
  //       this.unblock();
  //     }, maxBlockTimeMs);
  //   }
  // }
  //
  // unblock() {
  //   this.blockedCount--;
  //   if (this.blockedCount > 0) {
  //     return;
  //   }
  //   clearTimeout(this.autoUnblockTimeout);
  //   this.isBlocked = false;
  //   this.triggered.next(null);
  // }
  //
  // start() {
  //   this.isLoading = true;
  //   this.percent = 30;
  //   this.clearLoading();
  //   this.triggered.next(null);
  //
  //   this._timer = setInterval(() => {
  //     this.zone.run(() => {
  //       if (this.percent < this._threshold) {
  //         this.percent += 1;
  //       } else {
  //         this.percent = 80;
  //       }
  //       this.triggered.next(null);
  //     });
  //   }, 500);
  // }
  //
  // setPercent(p: number) {
  //   this.percent = p;
  //   this.triggered.next(null);
  // }
  //
  // clearLoading() {
  //   if (this._timer) {
  //     clearInterval(this._timer);
  //     this._timer = null;
  //     this.triggered.next(null);
  //   }
  // }
  //
  // showSpeed() {
  //   return (Math.round(this.speed / 100) / 10).toFixed(2);
  // }
  //
  // stop() {
  //   this.percent = 96;
  //   this.clearLoading();
  //   this.triggered.next(null);
  //
  //   const timeoutId = setTimeout(() => {
  //     this.zone.run(() => {
  //       this.isLoading = false;
  //       this.triggered.next(null);
  //     });
  //   }, 300);
  // }
  //
  //
  //
  // show404Modal(params: {
  //   header?: string;
  //   navigateToPath?: any[];
  //   navigateToText?: string;
  // }) {
  //
  //   const defaultParams = {
  //     header: 'Упс! Страница не найдена',
  //     navigateToPath: ['/'],
  //     navigateToText: 'На главную',
  //   };
  //
  //   params = {
  //     ...defaultParams,
  //     ...params,
  //   };
  //
  //   const modalRef = this.lgDialogService.showSimpleModal({
  //     header: params.header,
  //     text: 'Возможно вы <b>неправильно указали адрес</b>. Или страница была удалена.',
  //     img: 'admin_assets/svg/search_gray.svg',
  //     btns: [
  //       {
  //         text: params.navigateToText,
  //         type: 'primary',
  //       },
  //       {
  //         text: 'Нужна помощь',
  //         type: 'link' as any,
  //         close: false,
  //         action: () => {
  //           window.open(socialsLinks.telegram.link, '_blank');
  //         }
  //       }
  //     ],
  //     additionalClass: 'oops-404-modal',
  //   });
  //   const s = modalRef.onClose.subscribe(() => {
  //     this.router.navigate(params.navigateToPath);
  //     s.unsubscribe();
  //   });
  // }
}
